import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/shared/dictionary'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'pl-domki',
  messages
})

export default i18n

export function setMode(locale: string) {
  i18n.locale = locale
}
